import React from "react";
import { CustomButton } from "@/src/lib/ui"; // adjust path

// Reusable hidden input
const VisuallyHiddenInput = ({ onChange, multiple, accept }) => (
    <input
        type="file"
        onChange={onChange}
        multiple={multiple}
        accept={accept}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
    />
);

const FileUpload = ({
    buttonContent,
    onChange,
    customButtonStyles,
    accept,
}) => {
    return (
        <div className="relative">
            <CustomButton variant="contained" className={customButtonStyles}>
                {buttonContent || "Upload files"}
            </CustomButton>

            {/* Invisible file input over the button */}
            <VisuallyHiddenInput onChange={onChange} multiple accept={accept} />
        </div>
    );
};

export default FileUpload;
